// extracted by mini-css-extract-plugin
export default {"inputLabel":"EmailField_inputLabel__fUMN1","tooltipRequired":"EmailField_tooltipRequired__l2uf8"};